import WarningIcon from "@mui/icons-material/Warning";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export default function LoadingError(props) {
  const {
    title = "Error connecting to the server",
    text = "Please try again.",
  } = props;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <WarningIcon color="primary" sx={{ width: 100, height: 100, py: 1 }} />
      </Box>
      <Box sx={{ textAlign: "center", pb: 1 }}>
        <Typography align="center" variant="h6" sx={{ mb: 2 }}>
          {title ? title : "Error connecting to the server"}
        </Typography>
        <Typography color="textSecondary" align="center">
          {text ? text : "Please try again."}
        </Typography>
      </Box>
    </>
  );
}
